import { render } from "./cancelled-order.vue?vue&type=template&id=ca48555c&scoped=true"
import script from "./cancelled-order.vue?vue&type=script&lang=js"
export * from "./cancelled-order.vue?vue&type=script&lang=js"

import "./cancelled-order.vue?vue&type=style&index=0&id=ca48555c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca48555c"]])

export default __exports__